// MuestraArchivosCell.jsx
import React, { useEffect, useRef, useState } from "react";
import { Box, Skeleton } from "@mui/material";
import FileThumbnails from "../Estimates/FileThumbnails";
import { fetchMuestraFilesCached } from "../../utils/muestraFilesRequest";
import {
  getCachedArchivos,
  hasCachedArchivos,
} from "../../utils/cacheArchivos";
import { pickFilesForMuestraExportPhoto } from "../../utils/muestraFileCategories";

const MuestraArchivosCell = ({ muestra, refreshKey }) => {
  const [files, setFiles] = useState(() =>
    hasCachedArchivos(muestra.id)
      ? getCachedArchivosInitial(muestra.id)
      : null,
  );
  const rootRef = useRef(null);
  const muestraId = muestra?.id;

  useEffect(() => {
    if (!muestraId) {
      setFiles([]);
      return;
    }

    if (hasCachedArchivos(muestraId)) {
      setFiles(getCachedArchivosInitial(muestraId));
      return;
    }

    const node = rootRef.current;
    if (!node) return;

    let cancelled = false;

    const load = async () => {
      const data = await fetchMuestraFilesCached(muestraId);
      if (!cancelled) {
        setFiles(pickFilesForMuestraExportPhoto(data));
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        observer.disconnect();
        load();
      },
      { root: null, rootMargin: "120px", threshold: 0 },
    );

    observer.observe(node);

    return () => {
      cancelled = true;
      observer.disconnect();
    };
  }, [muestraId, refreshKey]);

  return (
    <Box
      ref={rootRef}
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: ".3em",
        py: ".3em",
        minHeight: 40,
      }}
    >
      {files === null &&
        [1, 2, 3].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width={40}
            height={40}
            sx={{ borderRadius: 1 }}
          />
        ))}

      {files &&
        files.map((file, i) => (
          <FileThumbnails key={i} filePath={file.path} />
        ))}
    </Box>
  );
};

function getCachedArchivosInitial(id) {
  const cached = getCachedArchivos(id);
  return Array.isArray(cached) ? pickFilesForMuestraExportPhoto(cached) : [];
}

export default MuestraArchivosCell;
